
<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">

<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="/">SATITA VITTAYAAREEKUL</a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <a class="nav-item nav-link" href="https://satitavitt.github.io/TagCloud/">FunFacts</a>
          <a class="nav-link js-scroll-trigger" routerLink="/blog">Blog</a>
          <a class="nav-link js-scroll-trigger" href="/draw">Draws</a>
          <a class="nav-item nav-link" routerLink="/bake">Baking</a>
          <a class="nav-item nav-link" routerLink="/comments">Comments</a>
<!--
          <ng-sidebar
            [(opened)]="_opened">
            <button class="demo-control" (click)="_toggleOpened()">Close sidebar</button>
            <hr>
            <a class="nav-link js-scroll-trigger" href="#signup">Contact</a>
            <a class="nav-item nav-link" routerLink="/login">Login</a>
            <a class="nav-item nav-link" routerLink="/register">Register</a>
            <a class="nav-item nav-link" routerLink="/userpage">User</a>
            <a *ngIf="currentUser" class="nav-item nav-link" (click)="logout()">Logout</a>
          </ng-sidebar>
-->       
          <div class="w3-dropdown-hover">
            <button class="w3-button w3-brown" style="margin-top : 20px"> Others <i class="fa fa-caret-down"></i></button>
            <div class="w3-dropdown-content w3-bar-block w3-border">
              <a class="w3-bar-item w3-button" href="#signup">Contact</a>
              <a class="w3-bar-item w3-button" routerLink="/login">Login</a>
              <a class="w3-bar-item w3-button" routerLink="/register">Register</a>
              <a class="w3-bar-item w3-button" routerLink="/userpage">User</a>
              

              <a *ngIf="currentUser" class="nav-item nav-link" (click)="logout()">Logout</a>
            </div>
          </div> 
  
        </ul>
        </div>   
<!--
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive01" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Others
            <i class="fas fa-bars"></i>
            <div class="collapse navbar-collapse" id="navbarResponsive01">
            <a class="nav-link js-scroll-trigger" href="#signup">Contact</a>
            <a class="nav-item nav-link" routerLink="/login">Login</a>
            <a class="nav-item nav-link" routerLink="/register">Register</a>
            <a class="nav-item nav-link" routerLink="/userpage">User</a>
            <a *ngIf="currentUser" class="nav-item nav-link" (click)="logout()">Logout</a>
          </div>
          </button>
          -->
    </div>
</nav>

<!--
  <header class="masthead">
    <div class="container d-flex h-100 align-items-center">
      <div class="mx-auto text-center">
        <h1 class="mx-auto my-0 text-uppercase">WELCOME</h1>
        <h2 class="text-white-50 mx-auto mt-2 mb-5">Here are some of the things I have done, feel free to leave a comment or suggestion at the end 🥳</h2>
        <a href="#about" class="btn btn-primary js-scroll-trigger">Start</a>
      </div>
    </div>
  </header>
-->
<!--
<div *ngIf="router.url === '/blog'">
   
    
    <div class="jumbotron jumbotron-fluid">
        <div class="row">
            <div class="body">
                <alert></alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div> -->

<router-outlet></router-outlet>

<app-footer></app-footer>
<!--
footer, comment, suggestion, and contact
<section class="contact-section navbar-expand-lg contact-section-color" id="contact">
    <div class="container">
        <div class = "row">
          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-map-marked-alt text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Located At</h4>
                <hr class="my-4">
                <div class="small text-black-50">The Hague, The Netherlands</div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-envelope text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Email</h4>
                <hr class="my-4">
                <div class="small text-black-50">
                  <a href="#">satita.ice.v@gmail.com</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3 mb-md-0">
            <div class="card py-4 h-100">
              <div class="card-body text-center">
                <i class="fas fa-mobile-alt text-primary mb-2"></i>
                <h4 class="text-uppercase m-0">Phone</h4>
                <hr class="my-4">
                <div class="small text-black-50">
                  +1(848)252-8552
                </div>
              </div>
            </div>
          </div>
        </div>
        
          <div class="social d-flex justify-content-center">
              <a href="#" class="mx-2">
                  <a href="https://www.linkedin.com/in/satita-vittayaareekul/"><i class="fab fa-linkedin"></i></a>
              </a>
              <a href="#" class="mx-2">
                  <a href="https://github.com/SatitaVitt"><i class="fab fa-github"></i> </a>
              </a>
          </div>
  </div>
  <footer class="small text-center text-white-50">
    <div class="container">
      Copyright &copy; Satita's Website 2023
    </div>
  </footer>
</section>
  
-->